import styled from "@emotion/styled";
import { MdsIcon } from "@/design-system/components/icon";
import { MDSBadgeVariant } from "@/mds/components/badge/badge.types";

export const StyledBadge = styled.span<{ $variant?: MDSBadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  border-radius: ${({ theme, $variant }) =>
    $variant === MDSBadgeVariant.EmphasisBig ? theme.borderRadius.max : theme.borderRadius.small};
  white-space: nowrap;
  user-select: none;
  padding: ${({ theme, $variant }) =>
      $variant === MDSBadgeVariant.EmphasisBig ? theme.spacing["1"] : theme.spacing["0"]}
    ${({ theme, $variant }) =>
      $variant === MDSBadgeVariant.EmphasisBig ? theme.spacing["2"] : theme.spacing["1"]};
  font-size: ${({ theme }) => theme.fontSizes.xxsmall};
  line-height: ${({ theme }) => theme.lineHeights.xsmall};
  font-weight: ${({ theme }) => theme.fontWeights.medium};

  color: ${({ theme, $variant }) => {
    switch ($variant) {
      case MDSBadgeVariant.Default:
        return theme.colors.text.secondary;
      case MDSBadgeVariant.Emphasis:
        return theme.colors.text.emphasis;
      case MDSBadgeVariant.MoreEmphasis:
        return theme.colors.text.emphasis;
      case MDSBadgeVariant.EmphasisBig:
        return theme.colors.text.onAccent;
      case MDSBadgeVariant.Negative:
        return theme.colors.text.negative;
    }
  }};

  background-color: ${({ theme, $variant }) => {
    switch ($variant) {
      case MDSBadgeVariant.Default:
        return theme.colors.background.badge.default;
      case MDSBadgeVariant.Emphasis:
        return theme.colors.background.badge.emphasis;
      case MDSBadgeVariant.MoreEmphasis:
        return theme.colors.background.badge.moreEmphasis;
      case MDSBadgeVariant.EmphasisBig:
        return theme.colors.background.badge.moreEmphasis;
      case MDSBadgeVariant.Negative:
        return theme.colors.background.badge.negative;
    }
  }};
`;

export const StyledIcon = styled(MdsIcon)`
  width: 12px;
  height: 12px;
  color: currentColor;
  .mds-icon {
    font-size: 9px;
  }
`;

export const StyledLabel = styled.span``;
